import { useRecoilValue } from 'recoil'
import parameterGroupsAtom from '@/pages/Parameters/parameterGroups.atom.ts'

const useParameterGroups = () => {
  return useRecoilValue(parameterGroupsAtom).items
}

export default useParameterGroups
